import { FunctionField } from 'react-admin';
import { PhoneNumberDto } from 'src/dtos';
import { formatPhoneNumber } from 'src/utils';

interface PhoneNumberArrayFieldProps {
  record?: PhoneNumberDto[] | PhoneNumberDto;
}

export const PhoneNumberArrayField = ({ record }: PhoneNumberArrayFieldProps) => {
  if (!record) {
    return null;
  }

  if (Array.isArray(record)) {
    return (
      <FunctionField
        label='Phone Numbers'
        record={record}
        render={(phoneNumbers: PhoneNumberDto[] = []) =>
          phoneNumbers.map(phoneNumber => (
            <div key={phoneNumber.type}>
              {phoneNumber.type} | {formatPhoneNumber(phoneNumber.phoneNumber)}
            </div>
          ))
        }
      />
    );
  }

  return (
    <FunctionField
      record={record}
      render={(phoneNumber: PhoneNumberDto) => {
        return (
          <div>
            {phoneNumber.type} | {formatPhoneNumber(phoneNumber.phoneNumber)}
          </div>
        );
      }}
      label='Phone Number'
    />
  );
};
